import {
  TouchEventHandler, useCallback, useRef, useState,
} from 'react';

function useSwipe() {
  const startYRef = useRef<number>();
  const startXRef = useRef<number>();
  const idRef = useRef<number>();
  const [ flags, setFlags ] = useState({ up: false, down: false, right: false, left: false });

  const touchEnd = useCallback((e: TouchEvent) => {
    const touch = Object.values(e.changedTouches).find((t) => t.identifier === idRef.current);
    if (!touch) return;
    const finalY = touch?.screenY;
    const finalX = touch?.screenX;

    setFlags({
      up: startYRef.current !== undefined ? startYRef.current - finalY > 40 : false,
      down: startYRef.current !== undefined ? finalY - startYRef.current > 40 : false,
      left: startXRef.current !== undefined ? startXRef.current - finalX > 40 : false,
      right: startXRef.current !== undefined ? finalX - startXRef.current > 40 : false,
    });

    window.removeEventListener('touchend', touchEnd);
  }, []);

  const touchStart: TouchEventHandler<HTMLDivElement> = useCallback((e) => {
    setFlags({ up: false, down: false, right: false, left: false });
    const touch = e.targetTouches[0];
    idRef.current = touch?.identifier;
    startYRef.current = touch?.screenY;
    startXRef.current = touch?.screenX;
    window.addEventListener('touchend', touchEnd);
  }, [ touchEnd ]);

  return {
    handlers: { onTouchStart: touchStart },
    ...flags,
  };
}

export { useSwipe };
